import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { UserRawScore, User, SurveyVersion } from '../../models';
import { UserDataService, UserRawScoreDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { UserStore, FilterStore } from '../../stores';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';
import { PVASelect } from '../../components';

interface UserRawScoreState {
    users: User[];
    userId: number;
    orgId: number;
    surveyId: number;
    surveyVersionId: number;
    surveyVersion: SurveyVersion | undefined;
    scores: UserRawScore[];
}

interface UserRawScoreProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

@inject('UserStore', 'FilterStore') @observer
export class UserRawScoreView extends React.Component<UserRawScoreProps, UserRawScoreState> {
    private userDataService = new UserDataService(this.props.notificationService);
    private userRawScoreDataService = new UserRawScoreDataService(this.props.notificationService);

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    @computed get userOrganization() {
        return this.props.UserStore!.userInfo.organization;
    }

    constructor(props: UserRawScoreProps) {
        super(props);

        this.state = {
            users: [],
            userId: 0,
            orgId: 0,
            surveyVersionId: 0,
            surveyId: 0,
            surveyVersion: undefined,
            scores: []
        };

        this.save = this.save.bind(this);
    }

    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    @computed get organizationName() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return `${this.props.FilterStore!.organization!.name}`;
        }
        return '';
    }

    private updateSurveyVersion(userId: number) {

        var user = this.state.users.find((u: User) => {
            return u.id === userId;
        });

        // if (!user && this.state.users.length > 0) {
        //     user = this.state.users[0];
        // }

        if (user && this.surveyVersion) {
            this.userRawScoreDataService.getBySurveyVersion(user, this.surveyVersion).then((userScores: UserRawScore[]) => {
                this.setState({
                    scores: userScores
                });
            });
        }
    }

    public Update() {
        if (this.organization && this.organization.id !== this.state.orgId) {
            this.setState({
                orgId: this.organization.id
            });
            var orgId = this.organization.id;
            this.userDataService.getByOrganizationLight(this.organization.id).then((users: User[]) => {
                this.setState({
                    users: users,
                    orgId: orgId
                });
                this.updateSurveyVersion(this.state.userId);
            });
        }

        if (this.surveyVersion && this.surveyVersion.id !== this.state.surveyVersionId) {
            this.setState({
                surveyVersionId: this.surveyVersion.id
            });
            this.updateSurveyVersion(this.state.userId);
        }
    }

    public componentDidMount() {
        this.Update();
    }

    componentWillReact() {
        this.Update();
    }

    public userChange(e: any) {
        var userId: number = Number(e.target.value);
        this.setState({
            userId: userId
        });

        if (this.surveyVersion) {
            this.updateSurveyVersion(userId);
        }
    }

    public render() {
        return (
            <div>
                {this.organization && <div id={`organization-${this.organization.id}`} />}
                {this.survey && <div id={`survey-${this.survey.id}`} />}
                {this.surveyVersion && <div id={`surveyVersion-${this.surveyVersion.id}`} />}
                
                <div className="content-header">
                    <div className="content-container">
                        <div className="title">
                            User Raw Scores <span className="light">for </span>
                            <PVASelect options={this.state.users} selected={this.state.userId} onChange={(e: any) => this.userChange(e)}/>
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">

                        <div className="row">
                            <div className="col-sm-6">
                                <h3>True/False Raw Scores</h3>
                                <table className="table">
                                    <tr>
                                        <td>Raw Score</td>
                                        <td>Score</td>
                                    </tr>
                                    {
                                        this.state.scores && this.state.scores.filter((s: UserRawScore) => {
                                            return s.scoreType.scoringType === 'trueFalse' || s.scoreType.scoringType === 'trueFalseInconsistent';
                                        }).map((score: UserRawScore) => {
                                            return <tr key={score.id}>
                                                <td>
                                                    <NavLink to={`/scoreType/${score.scoreType.id}`}>
                                                        {score.scoreType.name}
                                                    </NavLink>
                                                </td>
                                                <td>
                                                    <input type="number" className="form-control" value={score.score} />
                                                </td>
                                                </tr>;
                                        })
                                    }
                                </table>
                            </div>
                            <div className="col-sm-6">
                                <h3>Likert Raw Scores</h3>
                                <table className="table">
                                    <tr>
                                        <td>Raw Score</td>
                                        <td>Score</td>
                                    </tr>
                                    {
                                        this.state.scores && this.state.scores.filter((s: UserRawScore) => {
                                            return s.scoreType.scoringType === 'likert' || s.scoreType.scoringType === 'likertInconsistent';
                                        }).map((score: UserRawScore) => {
                                            return <tr key={score.id}>
                                                <td>
                                                    <NavLink to={`/scoreType/${score.scoreType.id}`}>
                                                        {score.scoreType.name}
                                                    </NavLink>
                                                </td>
                                                <td>
                                                    <input type="number" className="form-control" value={score.score} />
                                                </td>
                                                </tr>;
                                        })
                                    }
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);
    }

    private save(values: any) {
        this.userDataService.create(values).then((success) => {
            this.props.history.push('/user');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/userrawscore/UserRawScoreView.tsx